<template>
    <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-card>
        <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
          <v-flex xs10>
            <v-btn fab x-small @click="$router.go(-1)">
              <v-icon>navigate_before</v-icon>
            </v-btn>
          </v-flex>
        
          <v-flex xs2>
            <report-list-actions
            :reportOptions="reportOptions"
            :downloadFilename="reportListFilename"
            ></report-list-actions>
          </v-flex>

              <v-flex xs12>
                <h3 class="text-center mb-5">Vehicle Inspection Report</h3>
                <v-divider class="ml-4 mr-4 mb-3"></v-divider>
              </v-flex>
              
              <v-flex xs12 md2 class="pa-1">
                  <v-menu
                      ref="calendarMenu"
                      v-model="calendarMenu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="reportFilters.startDate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'
                          clearable
                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="reportFilters.startDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendarMenu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendarMenu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
                  
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                 <v-menu
                      ref="calendar2Menu"
                      v-model="calendar2Menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="reportFilters.endDate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules='requiredField'
                          clearable

                      ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="reportFilters.endDate"
                      no-title
                      scrollable
                      :rules='requiredField'

                      >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="calendar2Menu = false"
                      >
                          Cancel
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="$refs.calendar2Menu.save(date)"
                      >
                          OK
                      </v-btn>
                      </v-date-picker>
                  </v-menu>
              </v-flex>
              
              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Staff Status"
                  :items="staffStatuses"
                  v-model="reportFilters.staffStatus"
                  clearable
                ></v-select>
              </v-flex>

              <v-flex xs12 md3 class="pa-1 mb-2">
                <v-select 
                    label="Select Staff"
                    :items="filteredEmployees"
                    item-text="Name"
                    item-value="_id"
                    v-model="reportFilters.StaffID"
                    clearable
                  ></v-select>
              </v-flex>

              <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                 <v-btn @click="inspectionQuery()">Search</v-btn>
              </v-flex>

              <v-flex xs12 class="pa-2">
                  <v-data-table
                    :headers="headers"
                    :items="inspections"
                    sort-by="Date"
                    sort-desc
                    class="elevation-1"
                    :loading="isLoading"
                    loading-text="Loading Vehicle Inspections"
                    :options.sync="options"
                    :items-per-page="10"
                    :page="page"
                    :pageCount="pageCount"
                    :server-items-length="itemCount"
                  >
                  <template v-slot:item.select="{ item }">
                    
                      <v-btn
                        x-small
                        class="white--text"
                        color="#2b3990"
                        @click="viewInspection(item)"
                      >
                        View
                      </v-btn>
                               
                  </template>
                  <template v-slot:item.actions="{ item }"  >

                    <v-icon small class="mr-2" @click="viewInspection(item)">
                        mdi-eye
                    </v-icon>

                    <v-icon small @click="deleteInspection(item)">
                        mdi-delete
                    </v-icon>

                    </template>
                  </v-data-table>

                  <v-dialog v-model="dialog" max-width="80%">
                    <VehicleInspectionForm 
                    :vehicleData="vehicle" 
                    :documents="documents"
                    :mode="vehicleInspectionMode"
                    :VehicleType="VehicleType"
                    v-on:closeVehicleInspectionForm="closeVehicleInspectionForm($event)"></VehicleInspectionForm>
                  </v-dialog>

              </v-flex>
          </v-layout>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios'
// import { PDFDocument } from "pdf-lib";
import moment from 'moment'
// import Foot from '../components/Footer'
import VehicleInspectionForm from '../client/VehicleInspection/VehicleInspectionForm'
import ReportListActions from '@/components/Report/ReportListActions.vue'
import {
  STATUS_ARRAY,
  STATUSES as UserStatus
} from "../../enums/UserStatusEnum";
import { STATUSES as StaffStatus } from "../../enums/StaffStatusEnum";
import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../../client_config/config").url;

  export default {
    mixins: [
      ReportFilters,
    ],
    components: {
        VehicleInspectionForm,
        ReportListActions
    },
    data: () => ({
    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'Date',
      },
      { text: "Staff", value: "employeeName" },
      { text: "Vehicle", value: "VehicleType" },
      { text: "Starting Miles", value: "Start" },
      { text: "Ending Miles", value: "End" },
      { text: "Actions", value: "actions", sortable: false },

    ],
    startDate: "",
    endDate: "",
    StaffID: '',
    calendarMenu: false,
    calendar2Menu: false,
    dialog: false,
      editInspection: false,
      newInspection: false,
      msg: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      search: "",
      text:"",
      inspections: [],
      employees: [],
      userID: localStorage.getItem('userID'),
      employeeID: localStorage.getItem("staffId"),
      state: localStorage.getItem('userState'),
      inspectionID: "",
      newImage: [],
      isLoading: true,
      vehicle: null,
      vehicleInspectionMode: 'add',
      documents:[],
      VehicleType:'',
      requiredField: [
          v => !!v || 'This is required',
      ],
      staffStatus: "",
      staffStatuses: STATUS_ARRAY,
      reportListFilename: 'Vehicle Inspection Report',
      options: {},
      page: 1,
      pageCount: 1,
      itemCount: 0,
      reportFilters:  {
        startDate: '',
        endDate: '',
        StaffID: '',
        staffStatus: '',
      },
      reportFilterName: 'ReportFilters_VehicleInspection',
    }),

    computed: {
      filteredEmployees() {
        const employees = this.employees;

        if (this.staffStatus === UserStatus.INACTIVE) {
          return employees.filter(
            (employee) => employee.Status == StaffStatus.TERMINATED
          );
        }

        if (this.staffStatus === UserStatus.ACTIVE) {
          return employees.filter(
            (employee) =>
              employee.Status == StaffStatus.FULL_TIME ||
              employee.Status == StaffStatus.PART_TIME
          );
        }
        return employees;
      },
      
    
      queryParams() {
        let {page, sortBy, sortDesc, itemsPerPage} = this.options;      
        const sortField = sortBy ? sortBy[0] : 'Date';
        const sortDirection = sortDesc ? sortDesc[0] : 'desc';
  
        return {          
          staffStatus: this.reportFilters.staffStatus,
          startDate: this.reportFilters.startDate,
          endDate: this.reportFilters.endDate,
          staffID: this.reportFilters.StaffID,
          page: page,
          limit: itemsPerPage,
          sortField: sortField,
          sortDirection: sortDirection
        };
      },
  
      reportOptions() {
        return { 
            query: this.queryParams,
            endpoints: `inspections/printList`,
            dynamic: true
        }
      }
      
    },

    watch: {
        dialog(val) {
        val || this.close();
        },

        options: {
            handler() {
                this.inspectionQuery();
            },
            deep: true
        },
        reportFilters: {
          handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
          },
          deep: true
        }
    },

    created() {
        this.employeeID = this.$route.params.employeeID
        this.inspectionQuery();
        this.getEmployees();
        this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    },

    methods: {
      initialize() {
        this.inspections = [];
      },

      async getEmployees () {
        let endpoint = '';
        const companyIds = localStorage.getItem('userCompanies');

        endpoint = `${url}/users/state/${this.state}`;

        await axios.get(endpoint, {
          params: {
            Company: JSON.parse(companyIds)
          }
        }).then(res => {
          this.employees = res.data.users;
          
        });      

        // axios.get(`${url}/users/state/${this.state}`).then(res => {
        //   this.employees = res.data.users;
          
        // });      
      },
      
      inspectionQuery() {
        this.inspections = []
        this.isLoading = true;
         axios.get(`${url}/inspections/filter/${this.state}`, {
          params: this.queryParams,
        }).then(res => {
          const { docs, totalPages, totalDocs } = res.data;

          this.inspections = docs;
          this.inspections.map(inspection => {
            inspection.Date = moment(inspection.Date).format("MM/DD/YYYY");
            return inspection;
          });

          this.pageCount = totalPages;
          this.itemCount = totalDocs;
          this.isLoading = false;
          
        })
        
        
      },

      getStaffID(item) {
        this.staff = item.EmployeeID;
        window.localStorage.setItem('staffId', this.staff)
      },

    viewInspection(item) {
        this.vehicle = item;
        this.VehicleType = item.VehicleType;
        this.documents = [];
        this.newImage = [];

        this.getDocuments(item._id);
        this.newImage = this.documents.map((image) => {
            return {'name': image.Name}
        });

        this.vehicleInspectionMode = 'edit';
        this.dialog = true;
    },

      showAdd() {
        this.vehicleInspectionMode = 'add';
        this.vehicle = {};
        this.vehicle._id = null;
        this.vehicle.VehicleType = "";
        this.documents = [];
        this.newImage = [];
        this.vehicle.StaffID = this.employeeID;
        this.formTitle = 'New '
        this.dialog = true;
      },

        deleteInspection(item) {
          const id = item._id;
          confirm("Are you sure you want to delete this inspection?") &&
          this.inspectionDelete(id);
        },

        inspectionDelete(id) {
          axios.delete(`${url}/inspections/${id}`)
          .then((response) => {
              this.getInspections();
              if (response.status == 400) {
              response.json().then(function(data) {
                  return data.msg;
              });
              }
              this.msg=true;
              this.text="The inspection has been deleted successfully.";
          });
        },

        close() {
          this.dialog = false;
          this.$nextTick(() => {
              this.editedItem = Object.assign({}, this.defaultItem);
              this.editedIndex = -1;
          });
          this.clearData()
        },
        getInspections: function() {
          this.isLoading = true;

          axios.get(`${url}/inspections/filter/${this.state}`).then(res => {
              this.inspections = res.data.inspections;
              for (var i = 0; i < this.inspections.length; i++){
              this.inspections[i].Date = moment(this.inspections[i].Date).format("MM/DD/YYYY")
              }
          }).finally(() => this.isLoading = false);
        },
        
        clearData() {
          this.vehicle = {};
        },
        printTable() {
            window.print()
        },

        closeVehicleInspectionForm(data) {        
          if (data.message !== '') {
              this.msg = true;
              this.text = data.message;
          }
          this.dialog = false;
          this.inspectionID = data._id;

          this.clearData();
          this.getInspections();
        },
        
        getDocuments(id) {
            const inspectionDocumentQuery = {
                CategoryID: id
            }

            axios.get(`${url}/documents/query/`, {
                params: inspectionDocumentQuery
            })
            .then(res => {
                this.documents = res.data.documents;
            });

            return;
        }
    }
  }
</script>
<style>
#print {
  display: none
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}



@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  @media print { 
    #print{ 
    display: block; 
    border: none; 
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

    }
    

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none; 

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  
    
  } 
</style>